var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2437_38236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2437_38236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 11.8359H8.66927V7.83594H7.33594V11.8359ZM8.0026 6.5026C8.19149 6.5026 8.34983 6.43871 8.4776 6.31094C8.60538 6.18316 8.66927 6.02483 8.66927 5.83594C8.66927 5.64705 8.60538 5.48871 8.4776 5.36094C8.34983 5.23316 8.19149 5.16927 8.0026 5.16927C7.81371 5.16927 7.65538 5.23316 7.5276 5.36094C7.39983 5.48871 7.33594 5.64705 7.33594 5.83594C7.33594 6.02483 7.39983 6.18316 7.5276 6.31094C7.65538 6.43871 7.81371 6.5026 8.0026 6.5026ZM8.0026 15.1693C7.08038 15.1693 6.21372 14.9943 5.4026 14.6443C4.59149 14.2943 3.88594 13.8193 3.28594 13.2193C2.68594 12.6193 2.21094 11.9137 1.86094 11.1026C1.51094 10.2915 1.33594 9.42483 1.33594 8.5026C1.33594 7.58038 1.51094 6.71372 1.86094 5.9026C2.21094 5.09149 2.68594 4.38594 3.28594 3.78594C3.88594 3.18594 4.59149 2.71094 5.4026 2.36094C6.21372 2.01094 7.08038 1.83594 8.0026 1.83594C8.92483 1.83594 9.79149 2.01094 10.6026 2.36094C11.4137 2.71094 12.1193 3.18594 12.7193 3.78594C13.3193 4.38594 13.7943 5.09149 14.1443 5.9026C14.4943 6.71372 14.6693 7.58038 14.6693 8.5026C14.6693 9.42483 14.4943 10.2915 14.1443 11.1026C13.7943 11.9137 13.3193 12.6193 12.7193 13.2193C12.1193 13.8193 11.4137 14.2943 10.6026 14.6443C9.79149 14.9943 8.92483 15.1693 8.0026 15.1693ZM8.0026 13.8359C9.49149 13.8359 10.7526 13.3193 11.7859 12.2859C12.8193 11.2526 13.3359 9.99149 13.3359 8.5026C13.3359 7.01371 12.8193 5.7526 11.7859 4.71927C10.7526 3.68594 9.49149 3.16927 8.0026 3.16927C6.51371 3.16927 5.2526 3.68594 4.21927 4.71927C3.18594 5.7526 2.66927 7.01371 2.66927 8.5026C2.66927 9.99149 3.18594 11.2526 4.21927 12.2859C5.2526 13.3193 6.51371 13.8359 8.0026 13.8359Z",
    fill: "#4E2BD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.5a368a35dcad026734c4470fd1dc66b7.svg";
export { ForwardRef as ReactComponent };